export default __webpack_public_path__ + "static/TimMarsano-c1b437c5f62d04c951b8286c1e7020a8.jpg";